import classNames from 'classnames';
import React, {ReactNode} from 'react';

import './Modal.scss';

export enum ModalType {
  default,
  medium,
  small,
  verySmall,
}

type Padding = 'default' | 'm';

export interface ModalProps {
  children?: ReactNode;
  collapsed?: boolean;
  modalType?: ModalType;
  blocking?: boolean;
  spaceTop?: boolean;
  lightMode?: boolean;
  padding?: Padding;
}

export const Modal = React.forwardRef(
  (
    {
      children,
      collapsed,
      modalType = ModalType.default,
      blocking,
      spaceTop,
      lightMode,
      padding = 'default',
    }: ModalProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    return (
      <div
        ref={ref}
        className={classNames('content-wrapper__wrapper', {
          'content-wrapper__wrapper--backdrop': modalType === ModalType.default,
          'content-wrapper__wrapper--collapsed': collapsed,
          'content-wrapper__wrapper--blocking': blocking,
          'content-wrapper__wrapper--space-top': spaceTop,
        })}
      >
        <div
          className={classNames('content-wrapper', `content-wrapper--padding-${padding}`, {
            'content-wrapper--medium-window': modalType === ModalType.medium,
            'content-wrapper--small-window': modalType === ModalType.small,
            'content-wrapper--very-small-window': modalType === ModalType.verySmall,
            'content-wrapper--light-mode': lightMode,
          })}
        >
          {children}
        </div>
      </div>
    );
  }
);
